function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React from 'react';
import DoughnutChat from '../../components/doughnut-chart';
import { useQuery } from '@tanstack/react-query';
import { fetchUserTracficSource } from '../../../cores/api/api-dashboard';
import { OPTIONS_PERIOD_MODE_TRAFFIC_SOURCE } from '../../../contants/option';
export default function SectionSocialMediaChart() {
    var _a, _b;
    const _React$useState = React.useState('this_week'), _React$useState2 = _slicedToArray(_React$useState, 2), period = _React$useState2[0], setPeriod = _React$useState2[1];
    const _useQuery = useQuery({
        queryKey: ['fetchUserTracficSource', period],
        queryFn: () => fetchUserTracficSource({
            period
        }),
        keepPreviousData: true,
        suspense: true
    }), data = _useQuery.data;
    const source = (_a = data === null || data === void 0 ? void 0 : data.visit_data) !== null && _a !== void 0 ? _a : {
        direct_visit: {
            total: 0,
            percent: 0
        },
        ads_visit: {
            total: 0,
            percent: 0
        },
        search_engine_visit: {
            total: 0,
            percent: 0
        }
    };
    const values = [source.ads_visit.total, source.search_engine_visit.total, source.direct_visit.total];
    const totalUsers = (_b = data === null || data === void 0 ? void 0 : data.total_visits) !== null && _b !== void 0 ? _b : 0;
    return /*#__PURE__*/ React.createElement("div", {
        className: "p-4 bg-white rounded-lg"
    }, /*#__PURE__*/ React.createElement(DoughnutChat, {
        values: values,
        totalUsers: totalUsers,
        options: OPTIONS_PERIOD_MODE_TRAFFIC_SOURCE,
        onPeriodChange: setPeriod
    }));
}
